import { FlexBox, Loader, LoaderType } from '@fable/components'
import { css, useTheme } from '@fable/theme'

export const ScreenshotLoader = () => {
  const { colors } = useTheme()

  return (
    <FlexBox
      className={css`
        width: 100%;
        height: 352px;
        background-color: ${colors.uiPearlExtraLight};
        border-radius: 8px;
        position: relative;
      `}
      centerAll
    >
      <Loader type={LoaderType.contained} />
    </FlexBox>
  )
}
